import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { ORDER_STATUS } from 'domains/scraper-product/constants'

const propTypes = {
  order_status: PropTypes.string
}

/**
 * @param {string} status
 */
const ScraperProductCustomerOrderStatusBadge = ({ order_status }) => {

  const colorMap = {
    [ORDER_STATUS.UNORDERED]           : 'info',
    [ORDER_STATUS.ORDERED]             : 'warning',
    [ORDER_STATUS.PURCHASED_FROM_SITE] : 'primary',
    [ORDER_STATUS.ARRIVED]             : 'success'
  }

  const color = colorMap[order_status] || 'default'

  return <StatusBadge color={ color } label={ order_status } />
}

ScraperProductCustomerOrderStatusBadge.propTypes = propTypes

export default ScraperProductCustomerOrderStatusBadge